export const environment = {
  production: true,
  portalApi: "https://test.gaif-api.eg-insurtech.com/api",
  portalFileApi: "https://test.gaif-api.eg-insurtech.com/api",
  uiServerName: "https://test.gaif-portal.eg-insurtech.com/"


};
